export enum TreeEventType {
  EVENT_TYPE_FOCUS = 'focus',
  EVENT_TYPE_EXPAND = 'expand',
  EVENT_TYPE_COLLAPSE = 'collapse',
  EVENT_TYPE_SELECT = 'select',
  EVENT_TYPE_MOVE_UP = 'move-up',
  EVENT_TYPE_MOVE_DOWN = 'move-down',
}

export type TreeEvent = Readonly<{
  type: TreeEventType
  index: number
}>
